import { useTranslation } from 'react-i18next';
import { cn } from '@anytag/shared-utils';
import { PostDetailsType } from '@anytag/shared-types';

export interface CaptionProps extends Pick<PostDetailsType, 'caption'> {
  className?: string;
}

export const Caption = ({ caption, className }: CaptionProps) => {
  const { t } = useTranslation();

  return (
    <div className={cn('box-border flex-[1_1_0] overflow-y-auto rounded-md bg-black-10 p-2', className)}>
      {caption ? (
        <p className="text-sm font-normal break-all whitespace-pre-wrap text-black-90">{caption}</p>
      ) : (
        <div className="flex size-full items-center justify-center text-sm text-black-60">{t('No caption')}</div>
      )}
    </div>
  );
};
